import { ConfigSectionEditModel } from './models/config-section-edit.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { Section } from './models/section.model';

@Injectable({
  providedIn: 'root'
})
export class SectionService {

  //Behavior Subject for Custom Field
  private section = new BehaviorSubject('');

  getSection(): Observable<any> {
    return this.section.asObservable();
  }

  setSection(field) {
    this.section.next(field);
  }

  constructor(private http: HttpClient) { }

  getAllTypes() {
    return this.http.get<any>(`${environment.appOrgUrl}Type`)
  }

  getAllConfiguration() {
    return this.http.get<any>(`${environment.configUrl}Configuration`);
  }

  getAllModules() {
    return this.http.get<any>(`${environment.configUrl}LionO360_Object`)
  }

  updateConfiguration(obj) {
    return this.http.put<any>(`${environment.configUrl}Configuration`, obj)
      .toPromise()
      .then(res => res);
  }

  editConfiguration(obj) {
    return this.http.put<any>(`${environment.configUrl}Configuration/Edit`, obj)
  }

  checkAssociateSection(moduleId, sectionId) {
    return this.http.get<any>(`${environment.configUrl}Configuration/Section?sectionId=${sectionId}&objectId=${moduleId}`)
  }

  getConfigurationByModuleName(name) {
    return this.http.get<any>(`${environment.configUrl}Configuration/ConfigurationsByModuleName?name=${name}`)
  }

  getModuleSections(moduleId: number,channelId: number): Observable<Section[]> {
    return this.http.get<Section[]>(`${environment.configUrlV2}/Section/Module/${moduleId}?templateId=${channelId}`);
  }

  updateModuleSections(sectionData: ConfigSectionEditModel): Observable<ConfigSectionEditModel> {
    return this.http.put<ConfigSectionEditModel>(`${environment.configUrlV2}/Section`, sectionData);
  }
}
